import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Dialog } from '@/shared/ui/dialogs/Dialog';
import { Button } from '@/shared/ui/buttons/Button';
import { formatDateTime } from '@/shared/utils/date';
import type { ApiNotification } from '@/shared/types/api/notifications';

type AnnouncementModalProps = {
  notification: ApiNotification | null;
  onClose: () => void;
};

export const WidgetsNotificationsAnnouncementModal = ({
  notification,
  onClose,
}: AnnouncementModalProps) => {
  const { t } = useTranslation('notifications');
  const navigate = useNavigate();

  const link = notification?.link ?? '';

  // Close the modal, then navigate to the notification's deep link.
  const handleViewReceipt = () => {
    onClose();
    navigate(link);
  };

  return (
    <Dialog
      open={notification != null}
      onClose={onClose}
      title={t('announcementTitle')}
      size="lg"
      footer={
        <>
          {link && (
            <Button onClick={handleViewReceipt}>{t('viewReceipt')}</Button>
          )}
          <Button variant="outline" onClick={onClose}>
            {t('close')}
          </Button>
        </>
      }
    >
      {notification && (
        <div className="flex max-h-[60vh] flex-col gap-3 overflow-y-auto">
          {notification.image && (
            <img
              src={notification.image}
              alt={notification.text || t('imageAlt')}
              className="max-h-64 w-full rounded-2xl border border-slate-200 object-contain"
            />
          )}
          <p className="whitespace-pre-line break-words text-sm leading-relaxed text-ink">
            {notification.text}
          </p>
          <span className="text-xs text-ink-muted">
            {formatDateTime(notification.created_at)}
          </span>
        </div>
      )}
    </Dialog>
  );
};
